var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-popup"},[_c('h6',{staticClass:"map-popup__title"},[_vm._v(" Current location: ")]),_c('div',{staticClass:"map-popup__content"},[_c('p',[_c('strong',[_vm._v("Latitude:")]),_vm._v(" "+_vm._s(_vm.position.lat)+" ")]),_c('p',[_c('strong',[_vm._v("Longitude:")]),_vm._v(" "+_vm._s(_vm.position.lng)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }